// extracted by mini-css-extract-plugin
export default {"floatLeft":"DatePicker_floatLeft__Voq+N"};